import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DeleteModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isLoading?: boolean;
  itemCount?: number;
}

export function DeleteModal({
  open,
  onOpenChange,
  onConfirm,
  isLoading = false,
  itemCount = 1,
}: DeleteModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[380px]">
        <DialogHeader>
          <DialogTitle className="text-[20px] font-semibold text-[#051923]">
            Delete Client Risk Assessment{itemCount > 1 ? 's' : ''}
          </DialogTitle>
          <DialogDescription className="pt-2 text-[16px] leading-[1.5] text-[#051923]">
            Are you sure you want to delete{' '}
            {itemCount > 1 ? 'these risk assessments' : 'this risk assessment'}? You will have{' '}
            <span className="font-semibold">10 days</span> to recover the file
            {itemCount > 1 ? 's' : ''} before {itemCount > 1 ? 'they are' : 'it is'} deleted
            indefinitely.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-6 flex flex-col gap-3">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="h-[45px] w-full rounded-[5px] border-[#D4DAE0] text-[16px] font-medium"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="h-[45px] w-full rounded-[5px] bg-[#131313] text-[16px] font-medium text-white hover:bg-[#131313]/90"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
